module.exports = __webpack_public_path__ + "img/bed-double.08b165e4.jpeg";